<template>
  <div class="app-main-inner app-main-page" style="height:auto">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form :inline="true" label-width="50px" label-position="left" @submit.native.prevent>
          <el-form-item class="custom">
            <el-input
              v-model="filter.invoiceTitle"
              :placeholder="$t('CargoMsg.Cargo_PlsInput')+$t('CargoMsg.Cargo_InvoiceTitle')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button type="primary" @click="filter.pageNum=1;btnSearchClickHandler()">{{ $t('common.btn.query') }}</el-button>&nbsp;
        <!--批量修改开票抬头-->
        <el-button type="primary" @click="btnUpdateClickHandler">{{ $t('Partners.batchModifyInvoicingHeader') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="min-height:350px;">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :side-bar="sideBarDefs"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
        @gridReady="onGridReady"
      />
    </div>
    <div class="app-main-inner-row row-pagination" style="padding-right:0px;">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="btnSearchClickHandler"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('Partners.modifyInvoicingHeader')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('Payment.invoiceHeader')">
            <el-input v-model="editDialog.form.title" />
          </el-form-item>
          <el-form-item :label="$t('Partners.registrationNumber')">
            <el-input v-model="editDialog.form.taxAccount" />
          </el-form-item>
          <el-form-item :label="$t('Partners.invoiceAddress')">
            <el-input v-model="editDialog.form.address" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="editDialog.form.telephone" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchTitles, saveTitle } from '@/api/partner/title'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { cache } from '@/utils/cacheManager'
import $store from '@/store'

export default {
  name: 'EditInvoiceHead',
  props: {
    checkHQReadOnlyPermission: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: null,
      filter: {
        invoiceTitle: '',
        pageNum: 1,
        pageSize: 50,
        partnersApproved: 0
      },
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Partners.partnerAbbreviation'),
          field: 'cnShortName'
        },
        {
          headerName: this.$t('Partners.chineseNameOfPartner'),
          field: 'chineseName'
        },
        {
          headerName: this.$t('SeaExport.ChargeBranchId'),
          field: 'branchId',
          cellRenderer: params => {
            if (params.value === 1) {
              return 'HQ'
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('Payment.invoiceHeader'),
          field: 'title'
        },
        {
          headerName: this.$t('Partners.registrationNumber'),
          field: 'taxAccount'
        },
        {
          headerName: this.$t('Partners.invoiceAddress'),
          field: 'address'
        },
        {
          headerName: this.$t('SeaExport.Tel'),
          field: 'telephone'
        },
        {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultTitle',
          cellRenderer: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        }
      ],
      rowData: [],
      gridApi: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuidList: [],
          title: '',
          taxAccount: '',
          address: '',
          telephone: '',
          tenantId: ''
        }
      }
    }
  },
  methods: {
    onGridReady(params) {
      const self = this
      self.gridApi = params.api
      self.onGridDateRendered()
    },
    async btnSearchClickHandler() {
      if (!this.filter.invoiceTitle) {
        this.$message.warning(this.$t('Partners.enterBillingHeaderInformation'))
        return
      }
      const self = this
      self.loading = getLoading()
      self.filter.partnersApproved = Number(cache.config.get('PartnersApproved'))
      await searchTitles(self.filter).then(res => {
        self.rowData = res.data.list
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
        self.onGridDateRendered()
      })
      self.loading.close()
    },
    onGridDateRendered() {
      const self = this
      const columnApi = self.gridApi.columnController.columnApi
      const columnIds = []
      self.gridApi.columnController.gridColumns.forEach(p => {
        columnIds.push(p.colId)
      })
      setTimeout(() => {
        columnApi.autoSizeColumns(columnIds)
      })
    },
    btnUpdateClickHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const checkHQReadOnly = this.checkHQReadOnlyPermission(rows)
      if (!checkHQReadOnly) {
        return
      }
      this.editDialog.form = {
        uuidList: [],
        title: '',
        taxAccount: '',
        address: '',
        telephone: '',
        tenantId: rows[0].tenantId
      }
      this.editDialog.form.uuidList = rows.map(row => row.uuid)
      // for (const item of rows) {
      //   this.editDialog.form.uuidList.push(item.uuid)
      // }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      if (!form.title && !form.taxAccount && !form.address && !form.telephone) {
        this.editDialog.visible = false
        return
      }
      // 防止未输入栏数据更新进去
      for (const key in form) {
        if (form[key] === '') {
          form[key] = undefined
        }
      }
      form.branchId = $store.getters.currentOfficeId
      saveTitle(form).then(res => {
        this.btnSearchClickHandler()
        this.editDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
      })
    }
  }
}
</script>

<style>
</style>
